import { useMutation } from '@tanstack/react-query';
import { syncVideoStatsFetcher } from 'src/lib/fetchers/video-player-fetcher';

type registerVideoSessionType = {
  syncWatchStatsMutate: ReturnType<typeof useMutation>['mutate'];
  isLoading: boolean;
  error: unknown;
};

const useSyncWatchStats = (): registerVideoSessionType => {
  const { data, isLoading, error, mutate } = useMutation(['sync-stats'], syncVideoStatsFetcher, {
    retry: false,
  });

  return {
    isLoading,
    error,
    syncWatchStatsMutate: mutate,
  };
};

export default useSyncWatchStats;
